import { CustomApiHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    productId: string;
    qtyOrdered?: number;
    unitOfMeasure?: string;
}

type HandlerType = CustomApiHandler<Parameter>;

export const DispatchUpdateRelatedProductInfo: HandlerType = props => {
    props.dispatch({
        type: "Custom/relatedProductInfoLists/UpdateRelatedProductInfo",
        productId: props.parameter.productId,
        qtyOrdered: props.parameter.qtyOrdered,
        unitOfMeasure: props.parameter.unitOfMeasure,
    });
};

export const chain = [DispatchUpdateRelatedProductInfo];

const updateRelatedProductInfo = createHandlerChainRunner(chain, "UpdateRelatedProductInfo");

export default updateRelatedProductInfo;